var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22C17.0751 22 22 17.0751 22 11ZM2.00001 11C2.00001 7.21168 4.3406 3.97004 7.65455 2.64231C6.60557 4.6673 6 7.67236 6 11C6 14.3276 6.60557 17.3327 7.65456 19.3577C4.3406 18.03 2.00001 14.7883 2.00001 11ZM16 11C16 14.3276 15.3944 17.3327 14.3455 19.3577C17.6594 18.03 20 14.7883 20 11C20 7.21168 17.6594 3.97003 14.3455 2.6423C15.3944 4.6673 16 7.67236 16 11ZM8 11C8 5.98399 9.5936 2 11 2C12.4064 2 14 5.98399 14 11C14 16.016 12.4064 20 11 20C9.5936 20 8 16.016 8 11Z",
    fill: "#898F97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.063 9.65063L21.937 10.3493C21.1952 12.3387 16.3136 14 11 14C5.277 14 0.724084 12.5702 0.0418091 10.2862L1.95814 9.71377C2.07423 10.1024 2.94025 10.6865 4.40823 11.1475C6.13448 11.6896 8.44158 12 11 12C15.5473 12 19.716 10.5814 20.063 9.65063Z",
    fill: "#898F97"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopics);
export default __webpack_public_path__ + "static/media/topics.d300c03e671908ce7f09da5af4fed4ee.svg";
export { ForwardRef as ReactComponent };